import './main.less';
import React from 'react';
import cn from 'classname';

const Table = ({ table, intl, can, toggleExpandedAffiliates }) => (
	<div className="table-container banned-stat-table-container">
		<table className="simple-table banned-stat-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					<th className="fixed-col">Affiliate</th>
					{ table.headers.map((header, i) => (
						<th
							key={i} title="total banned/unique by phone banned"
							className="date-col"
						>
							{intl(header)}*
						</th>
					))}
				</tr>
			</thead>

			<tbody className='simple-table__body'>
				{table.rows.map((row, index) =>
					<Row
						row={row} can={can} key={index} headers={table.headers}
						toggleExpandedAffiliates={toggleExpandedAffiliates}
					/>
				)}
			</tbody>
		</table>
	</div>
);

class Row extends React.Component  {
	render() {
		const { row, headers, toggleExpandedAffiliates } = this.props;

		return (
			<tr className="stat-row">
				<td
					className={cn({ 'fixed-col': true, 'expanded-col': !!row.offer_name })}
					onClick={toggleExpandedAffiliates.bind(null, row.affiliate_id)}
				>
					<span>{!row.offer_name ? row.affiliate : `${row.offer_name}-${row.country_code}`}</span>
				</td>
				{headers.map((header, index) =>
					<td key={index}>
						{row[`count_${header}`]}/{row[`count_unique_${header}`]}
					</td>
				)}
			</tr>
		);
	}
}

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/components/table/unacceptable-stat/main.js